import {
    Component,
    OnInit,
    Input,
    OnChanges,
    Output,
    EventEmitter,
    OnDestroy,
    SimpleChanges,
    AfterViewInit, ViewChild
} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

import {gridConfig, gameModel} from '@myModels/Shared';
import {Globals} from '@myApp/globals.ts';
import {GameService} from '@myServices/game.service';
import {ModalService} from '@myServices/modal.service';
import {OverlayService} from '@myServices/overlay.service';
import {GameComponent} from '../game/game.component';
import {NotificationService} from '@myServices/notification.service';
import {MgWalletComponent} from '../mg-wallet/mg-wallet.component';
import {GeneralBehaviorSubjectService, GroupService, LocalService} from '@Shared/services';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';
import {Router} from '@angular/router';
import {NguCarousel, NguCarouselStore} from "@ngu/carousel";

@Component({
    selector: 'app-game-grid',
    templateUrl: './game-grid.component.html',
    styleUrls: ['./game-grid.component.scss']
})
export class GameGridComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

    public isMobile: Boolean;
    public totalViewed = 0;
    public iframeUrl: SafeResourceUrl = null;
    public selectedGame: any = null;
    @Input() public games: Array<gameModel>;
    @Input() public most: Array<gameModel>;
    @Input() public heading: String;
    @Input() public maxGames;
    @Input() public showGamesCount = true;
    @Input() public pageSize;
    @Input() public hideListGames = false;
    @Input() public gridSize: string;
    @Input() public isFluid: boolean;
    @Input() public incrementGames: boolean;
    @Input() public isLiveCasino: boolean;
    @Input() public isHeaderGames: boolean = false;
    @Input() public isMostPlayedGames: boolean = false;
    @Input() public isOpenInModal: boolean = true;
    @Input() public showMoreButton: boolean = true;
    @Input() public targetGameForOpen: { isMobile: boolean, game: gameModel } = null;
    @Input() public mostPlayedGamesId: string;
    @Input() public showCloseGameIcon = true;
    @Input() public isCarousel: boolean = false;

    @Output() public isGameOpen = new EventEmitter<boolean>();
    private unsubscribe$: Subject<any> = new Subject<any>();
    private currentUrl: string;
    private currentLanguage: string;

    public carouselTile: any = {
        grid: {xs: 2, sm: 3, md: 3, lg: 5, xl:5, all: 0},
        slide: 2,
        speed: 400,
        animation: 'lazy',
        point: {
            visible: true
        },
        load: 2,
        touch: true,
        easing: 'ease'
    };
    constructor(
        private globals: Globals,
        private gameService: GameService,
        private modalService: ModalService,
        private domSanitizer: DomSanitizer,
        private overlayService: OverlayService,
        private notificationService: NotificationService,
        private virtualBettingButtonStatus: GeneralBehaviorSubjectService,
        private localService: LocalService,
        private router: Router,
        private groupService: GroupService,
    ) {
    }

    ngOnInit() {
        if (this.incrementGames) {
            this.totalViewed = this.maxGames;
        }
        this.globals.getMobileStatus().subscribe(isMobile => {
            this.isMobile = isMobile;
        });
        this.globals.getSideBarStatus().subscribe(isSideBarOpen => {
        });
        this.watchChanges();
        this.isGameOpen.emit(false);
        this.currentUrl = location.href;
        this.currentLanguage = this.localService.currentLang;

    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.incrementGames && typeof changes.games !== 'undefined' && typeof changes.games.previousValue !== 'undefined') {
            this.totalViewed = this.maxGames;
        }


    }

    ngAfterViewInit() {
        if (this.isMostPlayedGames) {
            setTimeout(() => {
                this.getMostPlayedGames();
            }, 200);
        }
    }

    openGameDesktop(game: gameModel) {
        let responseReturned = false;
        this.overlayService.onOverlayChange(true);
        this.gameService.getGameInfo(game.id, false, this.currentUrl, this.currentLanguage).subscribe(resp => {
            responseReturned = true;
            if (!resp.status) {
                this.overlayService.onOverlayChange(false);
                return this.notificationService.error(resp.messages[0]);
            }
            const isMicroGaming = resp.data.microgaming;
            const gameDataGame = resp.data.gameData.game;

            if (typeof isMicroGaming !== 'undefined' && isMicroGaming === false) {
                //need to show wallet inside GameComponent.

                const inputs = {
                    isMobile: false,
                    isMicroGaming: true,
                    microGamingGame: gameDataGame
                };
                this.modalService.init(MgWalletComponent, inputs, {});
                this.overlayService.onOverlayChange(false);
            } else {

                const url = resp.data.gameData.iframeUrl;

                const inputs = {
                    iframeUrl: this.domSanitizer.bypassSecurityTrustResourceUrl(url),
                    game: gameDataGame
                };
                if (this.isOpenInModal) {
                    this.modalService.init(GameComponent, inputs, {}, false, {
                        modalElementId: 'my-game-modal',
                        overlayElementId: 'my-game-modal-overlay'
                    });
                } else {
                    this.selectedGame = inputs.game;
                    this.iframeUrl = inputs.iframeUrl;
                }
                this.overlayService.onOverlayChange(false);
                this.virtualBettingButtonStatus.changeVirtualBettingMobileButtonStatus(true);
            }
        }, error => {
            this.overlayService.onOverlayChange(false);
            this.notificationService.error(error);
        });
        setTimeout(() => {
            if (!responseReturned) {
                this.overlayService.onOverlayChange(false);
                return this.notificationService.error('SOMETHING_WENT_WRONG');
            }
        }, 5000);
    }

    openGameMobile(game: gameModel) {
        this.gameService.getGameInfo(game.id, true, this.currentUrl, this.currentLanguage).subscribe(resp => {
            if (!resp.status) {
                this.overlayService.onOverlayChange(false);
                return this.notificationService.error(resp.messages[0]);
            }
            const targetUrl = !!resp.data.gameData.mobileUrl ? resp.data.gameData.mobileUrl : resp.data.gameData.iframeUrl;
            const isMicroGaming = resp.data.microgaming;
            const gameDataGame = resp.data.gameData.game;

            if (typeof isMicroGaming !== 'undefined' && isMicroGaming === false) {
                //need to show wallet inside GameComponent.

                const inputs = {
                    fromMobile: true,
                    isMicroGaming: true,
                    microGamingGame: gameDataGame
                };
                this.modalService.init(MgWalletComponent, inputs, {});
                this.overlayService.onOverlayChange(false);
            } else if (location.href.includes('virtual-sports') || location.href.includes('header-game')) {
                const inputs = {
                    iframeUrl: this.domSanitizer.bypassSecurityTrustResourceUrl(targetUrl),
                    game: gameDataGame
                };

                this.selectedGame = inputs.game;
                this.iframeUrl = inputs.iframeUrl;
                this.overlayService.onOverlayChange(false);
            } else {
                location.href = targetUrl;
            }

        }, error => {
            this.overlayService.onOverlayChange(false);
            this.notificationService.error(error);
        });
    }

    increment() {
        this.totalViewed += this.maxGames;
    }

    viewAll() {
        this.router.navigateByUrl('/casino');
    }

    // public closeGame() {
    //     this.iframeUrl = null;
    //     this.selectedGame = null;
    //     this.isGameOpen.emit(false);
    // }
    private watchChanges() {
        this.virtualBettingButtonStatus.getVirtualBettingMobileButtonStatus().pipe(
            takeUntil(this.unsubscribe$)).subscribe(resp => {
            if (resp === false) {
                this.iframeUrl = null;
                this.selectedGame = null;
                this.isGameOpen.emit(false);
            }
        });
    }

    getMostPlayedGames() {
        this.groupService.getGamesByGroupId(this.mostPlayedGamesId).subscribe(resp => {
            if (resp.status && typeof resp.data.games !== 'undefined') {
                this.games = resp.data.games;
            }
        }, error => {
            this.notificationService.error(error);
        });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}






// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/game-grid/game-grid.component.ts